var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFolderIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9317_15293)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.375 7.35C17.025 7.35 16.75 7.075 16.75 6.725V1.875C16.75 1.525 16.475 1.25 16.125 1.25H4.875C4.525 1.25 4.25 1.525 4.25 1.875V4.375C4.25 4.725 3.975 5 3.625 5C3.275 5 3 4.725 3 4.375V1.875C3 0.8375 3.8375 0 4.875 0H16.125C17.1625 0 18 0.8375 18 1.875V6.725C18 7.075 17.725 7.35 17.375 7.35Z",
    fill: "#62585D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.625 20H2.375C1.3375 20 0.5 19.1625 0.5 18.125V5.625C0.5 4.5875 1.3375 3.75 2.375 3.75H8.3125C8.5125 3.75 8.7 3.8375 8.8125 4L10.5 6.25H18.625C19.6625 6.25 20.5 7.0875 20.5 8.125V18.125C20.5 19.1625 19.6625 20 18.625 20ZM2.375 5C2.025 5 1.75 5.275 1.75 5.625V18.125C1.75 18.475 2.025 18.75 2.375 18.75H18.625C18.975 18.75 19.25 18.475 19.25 18.125V8.125C19.25 7.775 18.975 7.5 18.625 7.5H10.1875C10.0901 7.50204 9.99372 7.48034 9.90661 7.43679C9.81949 7.39323 9.74429 7.32912 9.6875 7.25L8 5H2.375Z",
    fill: "#62585D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.375 16.25H4.875C4.525 16.25 4.25 15.975 4.25 15.625C4.25 15.275 4.525 15 4.875 15H7.375C7.725 15 8 15.275 8 15.625C8 15.975 7.725 16.25 7.375 16.25Z",
    fill: "#62585D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9317_15293"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderIcon);
export default __webpack_public_path__ + "static/media/folder-icon.27126508c2c4d89e784b8f7e02efaee1.svg";
export { ForwardRef as ReactComponent };